import { BASE_URL } from 'src/config/config';
import axios from 'axios';

const client = axios.create({ baseURL: BASE_URL });

export default client;
